import React, { Component, JSX } from 'react'

export default class IbssHomeCard extends Component<IProps>
{
    private handleClick(): void
    {
        const { href, onClick } = this.props;
        if (!href)
        {
            return;
        }
        onClick(href);
    }

    public render(): JSX.Element 
    {
        const { imageSource, imageAlt, title, description, href } = this.props;
        return (
            <div
                style={{ cursor: (href ? 'pointer' : 'default') }}
                onClick={() => this.handleClick()}
            >
                <div style={{
                    minHeight: 130,
                    display: 'flex',
                    boxShadow: 'var(--shadows-sd-system-elevation-shadow-level1)',
                }}>
                    <div
                        style={{
                            width: '130px',
                            minWidth: '130px',
                            overflow: 'hidden'
                        }}
                    >
                        {
                            imageSource &&
                            <img
                                src={imageSource}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                    display: 'block',
                                }}
                            />
                        }
                    </div>
                    <div style={{ margin: '0 0 16px 16px' }}>
                        <h3>{title}</h3>
                        <div>{description}</div>
                    </div>
                </div>
            </div >
        )
    }
}

interface IProps
{
    imageSource: string;
    imageAlt: string;
    title: string;
    description: string;
    href: string;
    onClick: (href: string) => void;
}